import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { useNavigate } from "react-router-dom";
import { cpfPercentageValidation } from "core/Operations/ValidationSchema/MasterValidationSchema";
import CPFPercentageForm from "Components/Form/CPFPercentageFrom";
import { useInsertCPFPercentageMutation } from "AppQuries/master/CpfPercenatge/cpf-percentage";
import { Link } from "react-router-dom";
const AddCPFPercentage = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: addCPFPercentage,
    isPending,
    isError,
    error,
  } = useInsertCPFPercentageMutation();
  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      code: 0,
      cpftype: "",
      ageFrom: "",
      ageTo: "",
      salaryFrom: 0,
      salaryTo: 0,
      employeePercentage: "",
      employerPercentage: "",
      // employeePercentageSalaryCeiling: "",
      isActive: true,
      createUser: userData.userName,
      createDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      modifyUser: userData.userName,
      modifyDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
    },
    resolver: yupResolver(cpfPercentageValidation),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  console.log(errors);
  const onSubmit = (payload) => {
    addCPFPercentage(payload, {
      onSuccess: (data) => {
        if (data === true) {
          setMessage("CPF Percentage Added Successfully.");
          setShowSuccessToast(true);
          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.cpfPercentage}`);
          }, 1000);
        } else {
          setMessage("Something went wrong.");
          setShowErrorToast(true);
        }
      },
      onError: (error) => {
        setMessage(error.message || "Something went wrong.");
        setShowErrorToast(true);
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="toast-container position-fixed top-0 end-0 p-3">
        <ToastNotification
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          message={message}
        />
      </div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New CPF Percentage</h4>
                    <h6>Add your new cpf percengate details </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save CPF Percentage
                      </Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save CPF Percentage
                      </Tooltip>
                    }
                  >
                    <Link
                      className="btn btn-secondary"
                      to={`${all_routes.master}${all_routes.cpfPercentage}`}
                    >
                      <i className="fa fa-reply me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Add CPF Percentage</h4>
                    </div>
                    <div className="card-body">
                      <CPFPercentageForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddCPFPercentage;

// import React, { useState } from "react";
// import * as Yup from "yup";
// import { Tooltip, Button, Table, Input, message as antdMessage } from "antd";
// import {
//   PlusCircleOutlined,
//   SaveOutlined,
//   DeleteOutlined,
// } from "@ant-design/icons";
// import { useSelector } from "react-redux";
// import { loggedInUser } from "core/redux/slice/authSlice";
// import {
//   useForm,
//   useFieldArray,
//   FormProvider,
//   Controller,
// } from "react-hook-form";
// import { format } from "date-fns";
// import { yupResolver } from "@hookform/resolvers/yup";
// import {
//   cpfContributionRateValidation,
//   cpfPercentageValidation,
// } from "core/Operations/ValidationSchema/MasterValidationSchema";
// import { useInsertCPFContributionRateMutation } from "AppQuries/master/CpfContributionRate/cpf-contribution-rate";
// import { useResidentialsQuery } from "AppQuries/master/ResidentialType/get-all-residential-type";
// import { useNavigate } from "react-router-dom";
// import { all_routes } from "Router/all_routes";
// import Select from "react-select";
// import CPFPercentageForm from "Components/Form/CPFPercentageFrom";

// const activeStatusOptions = [
//   { label: "Enable", value: true },
//   { label: "No", value: false },
// ];

// const AddCPFPercentage = () => {
//   const userData = useSelector(loggedInUser);
//   const { data: residentials } = useResidentialsQuery({
//     companyCode: userData?.companyCode,
//   });
//   const navigate = useNavigate();
//   const {
//     mutate: addCpfContribution,
//     isError,
//     error,
//   } = useInsertCPFContributionRateMutation();

//   const contributionOptions =
//     residentials?.data
//       ?.filter((r) => r.isActive === true)
//       .map((r) => ({ label: r.description, value: r.shortCode })) || [];

//   const methods = useForm({
//     defaultValues: { cpfPercentage: [] },
//     resolver: yupResolver(cpfPercentageValidation),
//   });

//   const {
//     handleSubmit,
//     control,
//     setValue,
//     watch,
//     formState: { errors },
//   } = methods;
//   const { fields, append, remove } = useFieldArray({
//     control,
//     name: "cpfPercentage",
//   });

//   const [showErrorToast, setShowErrorToast] = useState(false);
//   const [showSuccessToast, setShowSuccessToast] = useState(false);

//   const onSubmit = (payload) => {
//     const cpfPercentage = payload?.cpfPercentage || [];
//     console.log(cpfPercentage);
//     // addCpfContribution(cpfPercentage, {
//     //   onSuccess: (data) => {
//     //     antdMessage.success("CPF Contribution Rate Added Successfully.");
//     //     setTimeout(() => {
//     //       navigate(`${all_routes.master}${all_routes.cpfPercentage}`);
//     //     }, 1000);
//     //   },
//     //   onError: (error) => {
//     //     antdMessage.error(error.message || "Something went wrong.");
//     //   },
//     // });
//   };

//   const addRowHandler = () => {
//     append({
//       companyCode: userData.companyCode,
//       cpftype: "",
//       ageFrom: "",
//       ageTo: "",
//       salaryFrom: "",
//       salaryTo: "",
//       employeePercentage: "",
//       employerPercentage: "",
//       employeePercentageSalaryCeiling: "",
//       isActive: true,
//       createUser: userData.userName,
//       createDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
//       modifyUser: userData.userName,
//       modifyDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
//     });
//   };

//   return (
//     <div className="page-wrapper">
//       <FormProvider {...methods}>
//         <form onSubmit={handleSubmit(onSubmit)}>
//           <div className="content">
//             <div className="page-header">
//               <h4>Add CPF Percentage</h4>
//               <Tooltip title="Save CPF Percentage">
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   icon={<SaveOutlined />}
//                 >
//                   Save
//                 </Button>
//               </Tooltip>
//             </div>
//             <div className="card border-0">
//               <div className="card-header d-flex justify-content-between mb-3"></div>
//               <div className="card-body">
//                 <CPFPercentageForm />
//               </div>
//             </div>
//           </div>
//         </form>
//       </FormProvider>
//     </div>
//   );
// };

// export default AddCPFPercentage;

// // import React, { useState } from "react";
// // import * as Yup from "yup";
// // import { OverlayTrigger, Tooltip } from "react-bootstrap";
// // import { PlusCircle, Save, Trash2 } from "react-feather";
// // import ToastNotification from "Components/UI/ToastNotification";
// // import { useSelector } from "react-redux";
// // import { loggedInUser } from "core/redux/slice/authSlice";
// // import {
// //   FormProvider,
// //   useForm,
// //   useFieldArray,
// //   Controller,
// // } from "react-hook-form";
// // import { format } from "date-fns";
// // import { yupResolver } from "@hookform/resolvers/yup";
// // import { object, array, string, number } from "yup";
// // import Error404 from "MainPages/ErrorPages/error404";
// // import { all_routes } from "Router/all_routes";
// // import { Link, useNavigate } from "react-router-dom";
// // import { useInsertCPFContributionRateMutation } from "AppQuries/master/CpfContributionRate/cpf-contribution-rate";
// // import { useCPFContributionQuery } from "AppQuries/master/CpfContribution/contributions";
// // import { cpfContributionRateValidation } from "core/Operations/ValidationSchema/MasterValidationSchema";
// // import Select from "react-select";
// // import { useResidentialsQuery } from "AppQuries/master/ResidentialType/get-all-residential-type";
// // const activeStatusOptions = [
// //   {
// //     label: "Enable",
// //     value: true,
// //   },
// //   {
// //     label: "No",
// //     value: false,
// //   },
// // ];
// // const AddCPFPercentage = () => {
// //   const userData = useSelector(loggedInUser);
// //   const { data: residentials } = useResidentialsQuery({
// //     companyCode: userData?.companyCode,
// //   });
// //   const navigate = useNavigate();
// //   const {
// //     mutate: addCpfContribution,
// //     isError,
// //     error,
// //   } = useInsertCPFContributionRateMutation();
// //   console.log(residentials);
// //   const contributionOptions =
// //     residentials?.data
// //       ?.filter((r) => r.isActive === true)
// //       .map((r) => ({
// //         id: r.shortCode,
// //         label: r.description,
// //         value: r.shortCode,
// //       })) || [];

// //   const methods = useForm({
// //     defaultValues: { cpfPercentage: [] },
// //     resolver: yupResolver(cpfContributionRateValidation),
// //   });

// //   const {
// //     handleSubmit,
// //     control,
// //     setValue,
// //     watch,
// //     formState: { errors },
// //   } = methods;

// //   const { fields, append, remove } = useFieldArray({
// //     control,
// //     name: "cpfPercentage",
// //   });

// //   console.log(errors);

// //   const [message, setMessage] = useState("");
// //   const [showErrorToast, setShowErrorToast] = useState(false);
// //   const [showSuccessToast, setShowSuccessToast] = useState(false);

// //   const onSubmit = (payload) => {
// //     const cpfPercentage = payload?.cpfPercentage || [];
// //     addCpfContribution(cpfPercentage, {
// //       onSuccess: (data) => {
// //         console.log(data);
// //         if (data?.[0]?.response === true) {
// //           setMessage("CPF Contribution Rate Added Successfully.");
// //           setShowSuccessToast(true);
// //           setTimeout(() => {
// //             navigate(`${all_routes.master}${all_routes.cpfPercentage}`);
// //           }, 1000);
// //         } else {
// //           setMessage(data?.[0]?.errorMessage || "Something went wrong.");
// //           setShowErrorToast(true);
// //         }
// //       },
// //       onError: (error) => {
// //         setMessage(error.message || "Something went wrong.");
// //         setShowErrorToast(true);
// //       },
// //     });
// //   };

// //   const addRowHandler = () => {
// //     append({
// //       companyCode: userData.companyCode,
// //       code: 0,
// //       cpftype: 0,
// //       ageFrom: "",
// //       ageTo: "",
// //       salaryFrom: "",
// //       salaryTo: "",
// //       employeePercentage: "",
// //       employerPercentage: "",
// //       employeePercentageSalaryCeiling: "",
// //       isActive: true,
// //       createUser: userData.userName,
// //       createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
// //         new Date(),
// //         "HH:mm:ss.SSS"
// //       )}Z`,
// //       modifyUser: userData.userName,
// //       modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
// //         new Date(),
// //         "HH:mm:ss.SSS"
// //       )}Z`,
// //     });
// //   };

// //   if (isError) return <Error404 error={error} />;

// //   return (
// //     <div>
// //       <ToastNotification
// //         showSuccessToast={showSuccessToast}
// //         showErrorToast={showErrorToast}
// //         message={message}
// //       />
// //       <div className="page-wrapper">
// //         <FormProvider {...methods}>
// //           <form onSubmit={handleSubmit(onSubmit)}>
// //             <div className="content">
// //               <div className="page-header">
// //                 <h4>Add CPF Percentage</h4>
// //                 <h6>Create Cpf Percengate</h6>
// //                 <OverlayTrigger
// //                   placement="top"
// //                   overlay={<Tooltip>Save CPF Percentage</Tooltip>}
// //                 >
// //                   <button type="submit" className="btn btn-added">
// //                     <Save className="me-2" /> Save
// //                   </button>
// //                 </OverlayTrigger>
// //               </div>
// //               <div className="row">
// //                 <div className="col-md-12">
// //                   <div className="card border-0">
// //                     <div className="card-header d-flex justify-content-between mb-3">
// //                       <h4 className="card-title">CPF Percentage</h4>
// //                       <button
// //                         type="button"
// //                         className="btn btn-success btn-sm"
// //                         onClick={addRowHandler}
// //                       >
// //                         <PlusCircle className="me-2" /> Add Row
// //                       </button>
// //                     </div>
// //                     <div className="card-body">
// //                       <table className="table table-bordered">
// //                         <thead>
// //                           <tr>
// //                             <th style={{ width: "100px", textAlign: "center" }}>
// //                               Actions
// //                             </th>
// //                             <th>CPF Type</th>
// //                             <th>Age From</th>
// //                             <th>Age To</th>
// //                             <th>Employee Percentage</th>
// //                             <th>Employer Percentage</th>
// //                             <th>Total Percentage</th>
// //                             <th>Employee CPF Max Ceiling</th>
// //                             <th>Total CPF Max Ceiling</th>
// //                             <th>Status</th>
// //                           </tr>
// //                         </thead>
// //                         <tbody>
// //                           {fields.map((field, index) => (
// //                             <tr key={field.id}>
// //                               <td
// //                                 style={{ textAlign: "center" }}
// //                                 className="action-table-data"
// //                               >
// //                                 <div className="edit-delete-action">
// //                                   <div className="input-block add-lists"></div>
// //                                   <Link
// //                                     type="button"
// //                                     className="btn btn-sm me-2 p-2"
// //                                     onClick={() => remove(index)}
// //                                   >
// //                                     <Trash2 />
// //                                   </Link>
// //                                 </div>
// //                               </td>
// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].cpftype`}
// //                                   control={control}
// //                                   defaultValue={watch(
// //                                     `cpfPercentage[${index}].cpftype`
// //                                   )}
// //                                   render={({ field }) => (
// //                                     <Select
// //                                       {...field}
// //                                       options={contributionOptions}
// //                                       className={` ${
// //                                         errors?.cpfPercentage?.[index]?.cpftype
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                       value={contributionOptions.find(
// //                                         (option) => option.value === field.value
// //                                       )}
// //                                       onChange={(selectedOption) => {
// //                                         field.onChange(
// //                                           selectedOption
// //                                             ? selectedOption.value
// //                                             : ""
// //                                         );
// //                                       }}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]?.cpftype && (
// //                                   <div className="invalid-feedback">
// //                                     {
// //                                       errors.cpfPercentage[index].cpftype
// //                                         .message
// //                                     }
// //                                   </div>
// //                                 )}
// //                               </td>

// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].ageFrom`}
// //                                   control={control}
// //                                   render={({ field }) => (
// //                                     <input
// //                                       {...field}
// //                                       type="text"
// //                                       placeholder="Age From"
// //                                       className={`form-control ${
// //                                         errors?.cpfPercentage?.[index]?.ageFrom
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]?.ageFrom && (
// //                                   <div className="invalid-feedback">
// //                                     {
// //                                       errors.cpfPercentage[index].ageFrom
// //                                         .message
// //                                     }
// //                                   </div>
// //                                 )}
// //                               </td>

// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].ageTo`}
// //                                   control={control}
// //                                   render={({ field }) => (
// //                                     <input
// //                                       {...field}
// //                                       type="text"
// //                                       placeholder="Age To"
// //                                       className={`form-control ${
// //                                         errors?.cpfPercentage?.[index]?.ageTo
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]?.ageTo && (
// //                                   <div className="invalid-feedback">
// //                                     {errors.cpfPercentage[index].ageTo.message}
// //                                   </div>
// //                                 )}
// //                               </td>
// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].salaryFrom`}
// //                                   control={control}
// //                                   render={({ field }) => (
// //                                     <input
// //                                       {...field}
// //                                       type="text"
// //                                       placeholder="Salary From"
// //                                       className={`form-control ${
// //                                         errors?.cpfPercentage?.[index]
// //                                           ?.salaryFrom
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]?.salaryFrom && (
// //                                   <div className="invalid-feedback">
// //                                     {
// //                                       errors.cpfPercentage[index].salaryFrom
// //                                         .message
// //                                     }
// //                                   </div>
// //                                 )}
// //                               </td>
// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].salaryTo`}
// //                                   control={control}
// //                                   render={({ field }) => (
// //                                     <input
// //                                       {...field}
// //                                       type="text"
// //                                       placeholder="Salary To"
// //                                       className={`form-control ${
// //                                         errors?.cpfPercentage?.[index]?.salaryTo
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]?.salaryTo && (
// //                                   <div className="invalid-feedback">
// //                                     {
// //                                       errors.cpfPercentage[index].salaryTo
// //                                         .message
// //                                     }
// //                                   </div>
// //                                 )}
// //                               </td>
// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].employeePercentage`}
// //                                   control={control}
// //                                   render={({ field }) => (
// //                                     <input
// //                                       {...field}
// //                                       type="text"
// //                                       placeholder="Employee Percentage"
// //                                       className={`form-control ${
// //                                         errors?.cpfPercentage?.[index]
// //                                           ?.employeePercentage
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]
// //                                   ?.employeePercentage && (
// //                                   <div className="invalid-feedback">
// //                                     {
// //                                       errors.cpfPercentage[index]
// //                                         .employeePercentage.message
// //                                     }
// //                                   </div>
// //                                 )}
// //                               </td>
// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].totalPercentage`}
// //                                   control={control}
// //                                   render={({ field }) => (
// //                                     <input
// //                                       {...field}
// //                                       type="text"
// //                                       placeholder="Total Percentage"
// //                                       className={`form-control ${
// //                                         errors?.cpfPercentage?.[index]
// //                                           ?.totalPercentage
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]
// //                                   ?.totalPercentage && (
// //                                   <div className="invalid-feedback">
// //                                     {
// //                                       errors.cpfPercentage[index]
// //                                         .totalPercentage.message
// //                                     }
// //                                   </div>
// //                                 )}
// //                               </td>
// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].employeePercentageSalaryCeiling`}
// //                                   control={control}
// //                                   render={({ field }) => (
// //                                     <input
// //                                       {...field}
// //                                       type="text"
// //                                       placeholder="Employee Percentage Salary Ceiling"
// //                                       className={`form-control ${
// //                                         errors?.cpfPercentage?.[index]
// //                                           ?.employeePercentageSalaryCeiling
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]
// //                                   ?.employeePercentageSalaryCeiling && (
// //                                   <div className="invalid-feedback">
// //                                     {
// //                                       errors.cpfPercentage[index]
// //                                         .employeePercentageSalaryCeiling.message
// //                                     }
// //                                   </div>
// //                                 )}
// //                               </td>

// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].totalCpfMaxCeiling`}
// //                                   control={control}
// //                                   render={({ field }) => (
// //                                     <input
// //                                       {...field}
// //                                       type="text"
// //                                       placeholder="Total Cpf Max Ceiling"
// //                                       className={`form-control ${
// //                                         errors?.cpfPercentage?.[index]
// //                                           ?.totalCpfMaxCeiling
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]
// //                                   ?.totalCpfMaxCeiling && (
// //                                   <div className="invalid-feedback">
// //                                     {
// //                                       errors.cpfPercentage[index]
// //                                         .totalCpfMaxCeiling.message
// //                                     }
// //                                   </div>
// //                                 )}
// //                               </td>

// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].salaryFrom`}
// //                                   control={control}
// //                                   render={({ field }) => (
// //                                     <input
// //                                       {...field}
// //                                       type="text"
// //                                       placeholder="Salary From"
// //                                       className={`form-control ${
// //                                         errors?.cpfPercentage?.[index]
// //                                           ?.salaryFrom
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]?.salaryFrom && (
// //                                   <div className="invalid-feedback">
// //                                     {
// //                                       errors.cpfPercentage[index].salaryFrom
// //                                         .message
// //                                     }
// //                                   </div>
// //                                 )}
// //                               </td>
// //                               <td>
// //                                 <Controller
// //                                   name={`cpfPercentage[${index}].isActive`}
// //                                   control={control}
// //                                   defaultValue={watch(
// //                                     `cpfPercentage[${index}].isActive`
// //                                   )}
// //                                   render={({ field }) => (
// //                                     <Select
// //                                       {...field}
// //                                       options={activeStatusOptions}
// //                                       className={` ${
// //                                         errors?.cpfPercentage?.[index]?.isActive
// //                                           ? "is-invalid"
// //                                           : ""
// //                                       }`}
// //                                       value={contributionOptions.find(
// //                                         (option) => option.value === field.value
// //                                       )}
// //                                       onChange={(selectedOption) => {
// //                                         field.onChange(
// //                                           selectedOption
// //                                             ? selectedOption.value
// //                                             : ""
// //                                         );
// //                                       }}
// //                                     />
// //                                   )}
// //                                 />
// //                                 {errors?.cpfPercentage?.[index]?.isActive && (
// //                                   <div className="invalid-feedback">
// //                                     {
// //                                       errors.cpfPercentage[index].isActive
// //                                         .message
// //                                     }
// //                                   </div>
// //                                 )}
// //                               </td>
// //                             </tr>
// //                           ))}
// //                         </tbody>
// //                       </table>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </form>
// //         </FormProvider>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AddCPFPercentage;
